import 'css-chunksrc/client/scenes/projectMembersListingConfiguration/form/styles.scss';export default {
  "form": "_form_kbuly_1",
  "group": "_group_kbuly_5",
  "row": "_row_kbuly_9",
  "label": "_label_kbuly_19",
  "description": "_description_kbuly_24",
  "roleSelection": "_roleSelection_kbuly_28"
};